import qs from 'query-string'
import $global from '@xt/client/store/global'
import { $service } from '@xt/client/experimental/request/service'
import { reportEntryLog } from '@xt/client/utils/log'
import lodash from 'lodash'
import type { LaunchMiniProgramOptions, WXOpenSDK } from '@xt/client/types/wxopensdk.d'

export type MiniProgrmType = 'uc' | 'show' | 'wenfang' | 'daycourse'

export type OpenMiniProgrmOption = {
  path?: string
  miniProgrmType: MiniProgrmType
}

const appids: Record<MiniProgrmType, string> = {
  show: 'gh_08398972343c', // 暄桐展览
  wenfang: 'gh_79c64ca9ccaf', // 暄桐文房
  daycourse: 'gh_6df4e6c6d0bc', // 暄桐日课
  uc: 'gh_2f751118256c' // 暄桐
}

declare global {
  interface Window {
    wxopensdk?: WXOpenSDK
  }
}

export type Result = {
  success: boolean
  reason: string
}

/**
 *
 * @param type 要打开的小程序
 * @param path 小程序启动路径
 * @param query 小程序页面参数
 * @param timeout 超时时间
 */
export async function openMiniProgram(
  type: MiniProgrmType,
  path: `/${string}`,
  query: Record<string, any> = {},
  timeout: number = 5000
): Promise<Result> {
  const params = qs.stringify(query)

  if (params) {
    path += path.indexOf('?') === -1 ? `?=${params}` : `&=${params}`
  }

  console.warn(`小程序路径已经准备好: ${path}`)

  if ($global.platform !== 'PC') {
    reportEntryLog('system.open-mini.fail', { reason: '平台错误', platform: $global.platform, path })
    return {
      success: false,
      reason: '不支持的平台调用'
    }
  }

  if (!window.wxopensdk) {
    reportEntryLog('system.open-mini.fail', { reason: '找不到sdk实例', path })
    return {
      success: false,
      reason: '找不到sdk实例'
    }
  }

  // 获取本次接口需要的ticket
  const [err, ticket] = await $service<string>({
    url: `/uc/api/wxmp/opensdk/ticket`
  })

  if (err) {
    reportEntryLog('system.open-mini.get-ticket-fail', { err, path })
    return { success: false, reason: err.errMsg }
  }

  console.warn(`wxopensdk 是否ready: ${window.wxopensdk.ready} ticket = ${ticket}`)
  const options = { appid: $global.openAppid!, userName: appids[type], path, ticket, timeout } satisfies LaunchMiniProgramOptions

  if (window.wxopensdk.ready) {
    const launchResult = await window.wxopensdk.launchMiniProgram(options)

    console.log(launchResult)

    if (launchResult.errcode === 0) {
      return { success: true, reason: '' }
    }

    reportEntryLog('system.open-mini.fail', { ...launchResult, ...lodash.omit(options, 'ticket') })
    return { success: false, reason: launchResult.errmsg }
  }

  return new Promise<Result>(resolve => {
    window.wxopensdk!.onReady = async () => {
      const launchResult = await window.wxopensdk!.launchMiniProgram(options)

      if (launchResult.errcode === 0) {
        resolve({ success: true, reason: '' })
      } else {
        reportEntryLog('system.open-mini.fail', { ...launchResult, pos: 'onReady', ...lodash.omit(options, 'ticket') })
        resolve({ success: false, reason: launchResult.errmsg })
      }
    }
  })
}
